import React from 'react';

interface CoinDescriptionProps {
  coinName: string;
  coinSymbol: string;
  description: string;
  loading?: boolean;
}

export default function CoinDescription({
  coinName,
  coinSymbol,
  description,
  loading = false
}: CoinDescriptionProps) {
  if (loading) {
    return (
      <div className="bg-gradient-to-br from-indigo-500/10 to-purple-500/10 rounded-2xl p-6 border border-indigo-500/20">
        <div className="animate-pulse space-y-4">
          <div className="h-6 bg-indigo-500/20 rounded w-1/3"></div>
          <div className="h-4 bg-indigo-500/20 rounded"></div>
          <div className="h-4 bg-indigo-500/20 rounded w-5/6"></div>
          <div className="h-4 bg-indigo-500/20 rounded w-4/6"></div>
        </div>
      </div>
    );
  }

  if (!description || description.trim() === '') {
    return (
      <div className="bg-gradient-to-br from-indigo-500/10 to-purple-500/10 rounded-2xl p-6 border border-indigo-500/20">
        <h3 className="text-xl font-bold text-indigo-400 mb-4 flex items-center gap-2">
          <span className="text-2xl">📚</span>
          About {coinName}
        </h3>
        <p className="text-gray-400 italic">Description not available for this cryptocurrency.</p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-indigo-500/10 to-purple-500/10 rounded-2xl p-6 border border-indigo-500/20">
      <h3 className="text-xl font-bold text-indigo-400 mb-4 flex items-center gap-2">
        <span className="text-2xl">📚</span>
        About {coinName} ({coinSymbol.toUpperCase()})
      </h3>

      <div className="space-y-4">
        <div 
          className="text-gray-300 leading-relaxed prose prose-invert max-w-none prose-headings:text-indigo-400 prose-a:text-indigo-400 prose-strong:text-white"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div className="pt-4 border-t border-indigo-500/20">
          <p className="text-sm text-gray-500 italic">
            💡 This description is provided by CoinGecko for educational purposes.
          </p>
        </div>
      </div>
    </div>
  );
}

